import React, { useState, useEffect } from "react";
import {
    Button,
    Form,
    Input,
    Select,
    Modal,
    Row,
    Col,
} from "antd";
import { recordError } from "../../../utils/logService";

const CloseProjectModal = ({
    data,
    visible,
    onCancel,
    onModalSubmit,
}) => {
    const [booleanOptions, setBooleanOption] = useState([
        { value: "Yes", key: true },
        { value: "No", key: false },
    ]);
    const [modalTitle, setModalTitle] = useState("");
    const [disabled, setDisabled] = useState(true);
    const { TextArea } = Input;
    const { Option } = Select;
    const [form] = Form.useForm();
    const formName = "CloseProjectForm";

    const formItemLayout = {
        labelCol: {
            span: 18,
        },
        wrapperCol: {
            span: 20,
        },
        layout: "vertical",
    };

    useEffect(() => {
        loadProjectData();
    }, [data]);

    const loadProjectData = () => {
        setModalTitle("Close project - " + data.projectName);
        form.setFieldsValue({ id: data.id, feedback: false })
    }

    const onPopCancel = () => {
        onCancel();
        form.resetFields();
        setDisabled(true);
    };

    const onSubmit = async (values) => {
        try {
            const returnData = {
                "id": data.id,
                "feedback": "Yes",
                "comment": values.comment
            }
            onModalSubmit(returnData);
            form.resetFields();
        } catch (error) {
            recordError(error);
        }
    };


    return (
        <Modal
            title={modalTitle}
            open={visible}
            closable={false}
            keyboard={false}
            maskClosable={false}
            onCancel={onCancel}
            width={600}
            footer={[

                <div className="modal-footer-buttons">
                    <Button
                        onClick={() => onPopCancel()}
                    >Cancel</Button>
                    <Button
                        style={{ marginLeft: 10 }}
                        type="primary"
                        htmlType="submit"
                        onSubmit={onSubmit}
                        form={formName}
                    >
                        Save
                    </Button>

                </div>
            ]}
        >
            <Form
                {...formItemLayout}
                disabled={false}
                scrollToFirstError
                form={form}
                name={formName}
                onFinish={onSubmit}
            >
                <Row>
                    <Col xs={24} md={20}>
                        <h3 style={{ color: "red" }}>You will not be able to update this project when you close it.</h3>
                    </Col>
                    <br></br>
                    <Col xs={24} md={20}>
                        <Form.Item
                            name="comment"
                            label="Reason for the closure of the project"
                            rules={[
                                {
                                    required: true,
                                    message: "Please provide the reason for the project closure",
                                },
                            ]}

                        >
                            <TextArea
                                name="comment"
                                rows={4}
                                placeholder="Please provide reason to close the project..."
                                maxLength={400}
                                minLength={4}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

export default CloseProjectModal;
